import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { PlansPageTopTab, User } from '@app/models';
import { UserService } from '@app/services';

@Component({
  selector: 'app-verifications-credits-count',
  templateUrl: './verifications-credits-count.component.html',
  styleUrls: ['./verifications-credits-count.component.scss'],
  standalone: false
})
export class VerificationsCreditsCountComponent {
  @Input() user!: User;
  @Input() disableIcon = false;

  constructor(
    public userService: UserService,
    private router: Router
  ) {}

  totalCredits(): number {
    return (this.user?.subscription?.credits || 0) + (this.user?.subscription?.credits_bonus || 0);
  }

  goToCreditsPage(): void {
    this.router.navigate(['/perfil/planos'], { fragment: PlansPageTopTab.Credits });
  }
}
